module.exports = __webpack_public_path__ + "img/mobile3.fbbf7b12.png";